import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';
import { AppUIActions } from 'app/store/AppUI/AppUI.slice';
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';
// Selectors
import { selectNewDesignEnabled } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Mui
import { Divider } from '@mui/material';
// Components
import { Button } from 'app/components/Mui';

const NewDesignButton = () => {
  const { t } = useTranslation();

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);

  const handleClick = () => {
    // If new design is disabled, we will clear the selected pages
    if ( newDesignEnabled ) {
      dispatch(PagesToolbarActions.clearSelectedPages());
      dispatch(MixpanelActions.handleCasePagesSwitchToOldDesignClick());
    } else {
      dispatch(AppUIActions.toggleBatchesSidebar({ type: 'workspace',  value: false }));
      dispatch(MixpanelActions.handleCasePagesSwitchToNewDesignClick());
    }

    dispatch(PagesToolbarActions.toggleNewDesignEnabled());
  }

  const name = newDesignEnabled ? 'Switch to old design' : 'Switch to new design';
  const label = newDesignEnabled ? t('buttons.switchToOldDisign') : t('buttons.switchToNewDisign');

  return (
    <Fragment>
      <Divider sx={{ my: 1 }} />
      <Button
        name={name}
        onClick={handleClick}
        variant="outlined"
      >{label}</Button>
    </Fragment>
  )
}

export default NewDesignButton